const dependencies = ['main'];

const signIn = angular.module('signin', dependencies);

const autoload = require.context('.', true, /\.(html|json|woff|woff2|ttf|eot|svg|gif|png)$/);
const object = autoload.keys();
object.forEach((name) => {
  autoload(name);
});

signIn
  .config(require('./config/routes.js'))

  .service('RegistrationService', require('./services/registration-service.js'))

  .component('login', require(('./components/login/login.js')))
  .component('activation', require(('./components/activation/activation.js')))
  .component('register', require(('./components/register/register.js')))
  .component('forgotPassword', require(('./components/forgot-password/forgot-password.js')))
  .component('resetPassword', require(('./components/reset-password/reset-password.js')))
  .run(['$translate', '$translatePartialLoader', ($translate, $translatePartialLoader) => {
    $translatePartialLoader.addPart('signin');
    return $translate.refresh();
  },
  ]);

module.exports = signIn;



// WEBPACK FOOTER //
// ./signin/signin.js